export const FEATURE_FIXTURE_BETA = process.env.FEATURE_FIXTURE_BETA === 'true';
export const ENABLE_DEBUG_PANEL = false;
